/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const cookieBannerStyle = {
  banner: {
    position: "fixed",
    bottom: "1rem",
    left: "2%",
    minHeight: "50px",
    maxHeight: "calc(100vh - 6rem)",
    width: "96%",
    border: "1px solid #ddd",
    padding: "1rem 1.5rem 0.5rem 1.5rem",
    fontSize: 14,
    overflowY: "scroll",
  },
  headline: {
    fontSize: "1.25rem",
  },
  icon: {
    marginLeft: "10px",
  },
  modalContent: {
    fontSize: 14,
  },
};

export default cookieBannerStyle;
